import React from "react";
import { useTranslation } from "react-i18next";
import SEO from "components/SEO";
import EnergyBuyerSolutionHeaderAnalyse from "./EnergyBuyerSolutionHeaderAnalyse";
import EnergyBuyerSolutionSectionFour from "./EnergyBuyerSolutionSectionFour";
import EnergyBuyerSolutionSectionThree from "./EnergyBuyerSolutionSectionThree";
import EnergyBuyerSolutionSectionTwo from "./EnergyBuyerSolutionSectionTwo";
import DynamicAnalyse from "pages/DynamicAnalyse";

const SolutionPage = () => {
  const { t } = useTranslation("solutionEnergyBuyer");
  return (
    <>
      <SEO title={t("meta.title")} description={t("meta.description")} />
      <EnergyBuyerSolutionHeaderAnalyse />
      <EnergyBuyerSolutionSectionTwo />
      <EnergyBuyerSolutionSectionThree />
      <EnergyBuyerSolutionSectionFour />
      <DynamicAnalyse page="tenant" />
    </>
  );
};

export default SolutionPage;
